import React from 'react';
import { CreditCardIcon, UploadIcon, CalendarIcon, LinkIcon, ShieldCheckIcon, ShoppingBagIcon, RepeatIcon } from 'lucide-react';
import { PaymentType } from './PaymentForm';
interface PaymentTypeSelectorProps {
  activeType: PaymentType;
  onChange: (type: PaymentType) => void;
}
export function PaymentTypeSelector({
  activeType,
  onChange
}: PaymentTypeSelectorProps) {
  const paymentTypes = [{
    id: 'standard',
    name: 'Single',
    icon: CreditCardIcon
  }, {
    id: 'bulk',
    name: 'Bulk',
    icon: UploadIcon
  }, {
    id: 'installment',
    name: 'Split',
    icon: CalendarIcon
  }, {
    id: 'fixed-links',
    name: 'Fixed links',
    icon: LinkIcon
  }, {
    id: 'card-on-file',
    name: 'Charge',
    icon: CreditCardIcon
  }, {
    id: 'preauth',
    name: 'Security hold',
    icon: ShieldCheckIcon
  }, {
    id: 'shop-products',
    name: 'Shop',
    icon: ShoppingBagIcon
  }, {
    id: 'recurring',
    name: 'Recurring',
    icon: RepeatIcon
  }];
  return <div className="flex overflow-x-auto pb-2 -mb-px space-x-8" data-id="element-1366">
      {paymentTypes.map(type => {
      const Icon = type.icon;
      return <button key={type.id} className={`flex items-center pb-3 px-1 border-b-2 font-medium text-sm whitespace-nowrap ${activeType === type.id ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} onClick={() => onChange(type.id as PaymentType)} data-id="element-1367">
            <Icon size={18} className="mr-2" data-id="element-1368" />
            {type.name}
          </button>;
    })}
    </div>;
}